export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14000.a4635d1c.jpg";